import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import { ErrorWrap } from "../../../../helpers/error";
import { fetchFullAuditLog } from "../../../../redux/modules/audit-log";
import { buildSorter, buildSortColumn } from "../../../../helpers/sortby";
import { t } from "../../../../constant/translations";
import { getUrlParams } from "../../../../components/common/urlparams";
import dayjs from "dayjs";
import {
  DataTable,
  DataTableColumn,
} from "../../../../components/common/datatable";
import { DetailsModal } from "./details-modal";
import { Link } from "react-router-dom";
import { reverse, routes } from "../../../../routes";

const AuditListComponent = () => {
  const location = useLocation();
  const history = useHistory();
  const sortBy = buildSorter({ location, history });
  const sortColumn = buildSortColumn({ sortBy, location });
  const auditLog = useSelector((state) => state.auditLog.entities);
  const users = useSelector((state) => state.user.entities);
  const blocks = useSelector((state) => state.blocks.entities);
  const error = useSelector((state) =>
    ErrorWrap.fromError(state.auditLog.error || state.user.error)
  );
  const loading = useSelector(
    (state) => state.auditLog.pending || state.user.pending
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const params = {
      ...getUrlParams(location),
    };
    dispatch(fetchFullAuditLog(params));
  }, [location.search]);

  if (error.exists()) {
    return <div>{error.getGlobal()}</div>;
  }
  if (!auditLog || !users) {
    return <Loader active />;
  }
  if (loading) {
    return <Loader active />;
  }
  return (
    <DataTable data={auditLog} sortable={true}>
      <DataTableColumn
        name={t("labels.user")}
        render={(logEntry) => (
          <Link
            to={reverse(routes.teamDetails, {
              userId: logEntry.user.id,
            })}
          >
            {logEntry.user.name}
          </Link>
        )}
      />
      <DataTableColumn
        name={t("labels.block")}
        render={(logEntry) => {
          if (!logEntry.response) {
            return "";
          }
          if (
            logEntry.response.block &&
            typeof logEntry.response.block == "object"
          ) {
            return logEntry.response.block.name;
          }
          if (
            logEntry.response.block &&
            typeof logEntry.response.block == "number"
          ) {
            let block = blocks.find((e) => {
              return e.id === logEntry.response.block;
            });
            return block.name;
          }
        }}
      />
      <DataTableColumn
        name={t("labels.action")}
        render={(logEntry) =>
          t(`logActions.${logEntry.action}`, logEntry.action)
        }
      />

      <DataTableColumn
        name={t("labels.resource")}
        render={(logEntry) => {
          try {
            return t(`resources.${logEntry.resource}`, logEntry.resource);
          } catch (error) {
            return logEntry.resource;
          }
        }}
      />
      <DataTableColumn
        name={t("labels.date")}
        render={(logEntry) =>
          dayjs(logEntry.created_at).format("YYYY-MM-DD HH:mm")
        }
        {...sortColumn("created_at")}
      />
      <DataTableColumn
        name={t("management.details")}
        render={(logEntry) => <DetailsModal entry={logEntry} />}
      />
    </DataTable>
  );
};

export const AuditList = AuditListComponent;
